import type {CryptoNetwork} from './types';

const absurd = (x: never): never => {
  throw new Error(`Unexpected value: ${JSON.stringify(x)} -> ${typeof x}`);
};

export const getExplorerUrlForTransaction = ({
  network,
  mainnet,
  blockchainTxId,
}: {
  network: CryptoNetwork;
  mainnet: boolean;
  blockchainTxId: string;
}): string | null => {
  if (!blockchainTxId) {
    return null;
  }

  switch (network) {
    case 'ethereum':
      return mainnet
        ? `https://etherscan.io/tx/${blockchainTxId}`
        : `https://sepolia.etherscan.io/tx/${blockchainTxId}`;
    case 'solana':
      return mainnet
        ? `https://solscan.io/tx/${blockchainTxId}`
        : `https://solscan.io/tx/${blockchainTxId}?cluster=testnet`;
    case 'polygon':
      return mainnet
        ? `https://polygonscan.com/tx/${blockchainTxId}`
        : `https://amoy.polygonscan.com/tx/${blockchainTxId}`;
    case 'base':
      return mainnet
        ? `https://basescan.org/tx/${blockchainTxId}`
        : `https://sepolia.basescan.org/tx/${blockchainTxId}`;
    case 'tempo':
      return mainnet
        ? `https://explore.mainnet.tempo.xyz/receipt/${blockchainTxId}`
        : `https://explore.testnet.tempo.xyz/receipt/${blockchainTxId}`;
    default:
      return absurd(network);
  }
};
